<template>
  <div class="chat">
    <div
      class="chat-question-cards"
      data-qa="chat-question-cards">
      <div
        v-for="(question, questionIndex) in item.questions"
        :key="`question-${question.questionId}-${questionIndex}`"
        class="chat-question"
        :data-qa="`question-${question.questionId}-${questionIndex}`">
        <div
          class="chat-question-org"
          :data-qa="`chat-question-org-${question.questionId}-${questionIndex}`">
          <span
            class="chat-question-org-name"
            data-qa="question-org-name">{{ question.orgContact.userName }}</span>
          <span
            class="chat-question-org-date"
            data-qa="question-org-date">{{ $d(new Date(question.modifiedDate), "shortDate") }}, {{ $d(new Date(question.modifiedDate), "time") }}</span>
          <sButton
            v-if="accessEdit"
            icon="edit"
            small
            style="padding: 0; min-height: 0;"
            type="text"
            @click="$emit('edit', question)"/>
        </div>
        <div
          class="chat-question-message"
          data-qa="question-message">
          {{ question.message }}
        </div>
        <QuestionsChatAttachment
          v-for="(attachment) in question.attachments"
          :key="`question-attachment-${attachment.key}`"
          :attachment="attachment"
          mode="right"/>
        <template v-if="question.particpantContact.answers && question.particpantContact.answers.length">
          <div
            v-for="(answer, answerIndex) in question.particpantContact.answers"
            :key="`question-${question.questionId}-answer-${answerIndex}`"
            class="chat-answer"
            :data-qa="`question-${question.questionId}-answer-${answerIndex}`">
            <div class="chat-answer-user">
              <span
                class="chat-answer-user-name"
                data-qa="question-answer-name">{{ answer.answerContact.userName }}</span>
              <span
                class="chat-answer-user-date"
                data-qa="question-answer-date">{{ $d(new Date(answer.sendTime)) }}, {{ $d(new Date(answer.sendTime), "time") }}</span>
            </div>
            <div
              class="chat-answer-message"
              data-qa="answer-message">
              {{ answer.message }}
            </div>
            <QuestionsChatAttachment
              v-for="(attachment) in answer.attachments"
              :key="`answer-attachment-${attachment.key}`"
              :attachment="attachment"/>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import QuestionsChatAttachment from 'components/common/blocks/questions/QuestionAttachments.vue'

/**
 * Чат вопросов к поставщику
 */
export default {
  name: 'questionsChat',
  data() {
    return {
      showMenu: false,
      loading: false,
    }
  },
  methods: {
    scrollToLastItem() {
      setTimeout(() => {
        const itemActive = document.getElementsByClassName('chat-question')
        if (itemActive?.length) {
          itemActive[itemActive.length - 1].scrollIntoView({block: 'center', behavior: 'smooth'})
        }
      }, 250)
    },
  },
  created() {
    this.scrollToLastItem()
  },
  watch: {
    item: {
      deep: true,
      handler() {
        this.scrollToLastItem()
      }
    },
    show: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.scrollToLastItem()
        }
      }
    }
  },
  props: {
    item: {
      type: Object,
      require: true
    },
    show: {
      type: Boolean
    },
    /**
     * Тестовая фича. Этот функционал на беке вышел случайно, поэтому никому его не даем
     */
    accessEdit: {
      type: Boolean
    },
  },
  components: {
    QuestionsChatAttachment
  }
}
</script>
<style scoped lang="scss">
%extend_1 {
	margin-left: 10px;
	font-size: 12px;
	line-height: 16px;
	opacity: 0.5;
}


.chat-question {
	margin-top: 10px;
	&:first-child {
		margin-top: 0;
	}
}
.chat-question-org {
	display: flex;
	justify-content: flex-end;
}
.chat-answer {
	margin-top: 10px;
}
.chat-answer-user {
	display: flex;
	justify-content: flex-start;
}
.chat-answer-user-name {
	font-size: 14px;
	line-height: 18px;
}
.chat-question-org-name {
	font-size: 14px;
	line-height: 18px;
}
.chat-answer-user-date {
	@extend %extend_1;
}
.chat-question-org-date {
	@extend %extend_1;
}
.chat-answer-message {
	background: var(--green_chosen_light);
	padding: 20px;
	margin-top: 6px;
  white-space: pre-line;
	border-radius: 0 25px 25px 25px;
}
.chat-question-message {
	padding: 20px;
	margin-top: 5px;
  white-space: pre-line;
	background: var(--color-main-green);
	border-radius: 25px 0 25px 25px;
}
.chat-question-cards {
	background: var(--v-main__light_green-base);
	padding: 0 30px 5px 20px;
	border-radius: 0 0 8px 8px;
}
</style>
